<template>
    <div class="container">
        <div class="col-md-12">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="col-md-8 d-flex justify-content-end">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="createTipoContrato()">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-if="tipoContrato.length > 0">
            <div class="col-md-5">
                <b-table
                    :items="tipoContrato"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @row-clicked="(item) => editTipoContrato(item.id)"
                >
                    <template #cell(tipo_contrato)="data">
                        <div class="text-right">{{ data.item.tipo_contrato }}</div>
                    </template>
                </b-table>
                <div class="row col-md-12 mt-1">
                    <div class="col-md-10 d-flex justify-content-center">
                        <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="tipoContrato.length"
                        align="center"
                        size="md"
                        class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-md-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 20, 50, 100, 500]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
                <!-- <md-table md-card md-header v-model="tipoContrato">
                    <md-table-row slot="md-table-row" slot-scope="{ item }" @click="editTipoContrato(item.id)">
                        <md-table-cell :md-label="labels.codigo" class="border">{{ item.tipo_contrato }}</md-table-cell>
                        <md-table-cell :md-label="labels.descripcion" class="border text-left">{{ item.descripcion }}</md-table-cell>
                    </md-table-row>
                </md-table> -->
            </div>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <Crear :modalCrear="showTipoContrato" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showEditTipoContrato" :infoEdit="dataTipoContrato" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>

import TipoContrato from '../../../services/TipoContrato'
import Crear from './Crear'
import Editar from './Editar'

export default {
    name:'TipoContrato',
    components:{Crear,Editar},
    data:() => ({
        tipoContrato : [],
        showTipoContrato : false,
        showEditTipoContrato : false,
        dataTipoContrato : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'tipo_contrato', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Tipo contrato",
                    codigo : "Código",
                    descripcion : "Descripción",
                    noRow : "No hay registros"
                }
            }else{
                return {
                    title: "Contract type",
                    codigo : "Code",
                    descripcion : "Description",
                    noRow : "There are not records"
                }
            }
        }
    },
    methods:{
        createTipoContrato(){
            this.showTipoContrato = true
        },
        editTipoContrato(id){
            // console.log('editTipoContrato',id);
            TipoContrato.getTipoContratoById(id)
            .then((res) => {
                // console.log(res.data.tipoContrato);
                this.dataTipoContrato = res.data.tipoContrato
                this.showEditTipoContrato = true
            })
            .catch((error) => { console.log(error);})
        },
        closeModal(val){
            this.showTipoContrato = val
            this.showEditTipoContrato = val
        }
    },
    mounted(){
        TipoContrato.getAllTipoContrato()
        .then((res) => {
            // console.log(res.data.listTipoContrato)
            this.tipoContrato = res.data.listTipoContrato
        })
        .catch((err) => { console.log(err)})
    }
}
</script>

<style>

</style>